import { EmploymentStatus, NamedItem, UserClassAssignment, UserToImport } from 'core'

import { SimpleSelect, Table } from 'common/components'
import { mapEnumObjectKeys } from 'common/enumFormatters'

type EligibleEmployeesIchraRenewalTableProps = {
  employees: UserToImport[]
  productClasses: NamedItem[]
  onAddToSubmitList: (id: string, value: string) => void
  submitList: UserClassAssignment[]
}

const ImportEmployeesTable = ({
  employees,
  productClasses,
  onAddToSubmitList,
  submitList,
}: EligibleEmployeesIchraRenewalTableProps) => {
  const columns: any[] = [
    {
      title: 'First name',
      dataIndex: 'firstName',
      key: 'firstName',
    },
    {
      title: 'Last name',
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Work email',
      dataIndex: 'workEmail',
      key: 'workEmail',
    },
    {
      title: 'Status',
      dataIndex: 'employmentStatus',
      key: 'employmentStatus',
      render: (value: number) => {
        return <span>{mapEnumObjectKeys(EmploymentStatus)[value]}</span>
      },
    },
    {
      title: 'Class assignment',
      key: 'employmentStatus',

      render: (_, record) => {
        const isUnassigned = !submitList.map((x) => x.companyUserId).includes(record.id)
        return (
          <SimpleSelect
            defaultValue={null}
            onChange={(value) => onAddToSubmitList(record.id, value)}
            status={isUnassigned ? 'warning' : null}
            items={[
              {
                name: <div className="flex flex__align_center color-yellow-7">Unassigned</div>,
                id: null,
              },
              ...productClasses,
            ]}
          />
        )
      },
    },
  ]

  return <Table dataSource={employees} columns={columns} scroll={{ x: 1000 }} />
}

export default ImportEmployeesTable
